import { useState, useEffect } from "react";
import isEmpty from "lodash/fp/isEmpty";
import TreeCategory from "@rio-cloud/rio-uikit/TreeCategory";
import { AssetGroup, Asset } from "../../models/asset";
import { fetchAssetGroups } from "../../api/fetchAssetGroups";
import UptimeSidebar from "./UptimeSidebar";
import { Loading } from "../../utils/loading";
import InfoDialog from "../dialogs/InfoDialog";

import useAssets from "../../hooks/useAssets";

import "./styles.scss";

const CATEGORY_FILTER = "filter";
const CATEGORY_ASSETS = "assets";
const FIELD_CAMPAIGN_GROUP_ID = "field-campains-group";

interface IAssetsTreeProps {
  assetIds: string[];
  groupIds: string[];
  setAssetIds: (assetIds: string[]) => void;
  setGroupIds: (groupIds: string[]) => void;
  selectionLimit?: number;
}

const AssetTreeSidebar = (props: IAssetsTreeProps) => {
  const { allAssets } = useAssets();
  const [assets, setAssets] = useState<Asset[]>([]);
  const [assetGroups, setAssetGroups] = useState<AssetGroup[]>([]);
  const [loading, setLoading] = useState(true);
  const [error,] = useState<string | null>(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [showLimitDialog, setShowLimitDialog] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const groups = await fetchAssetGroups();
      const knownGroupIds = [...groups.map(group => group.id), FIELD_CAMPAIGN_GROUP_ID];
      const normalizedAssets = allAssets.map((asset: Asset) => ({
        ...asset,
        groupIds: asset.groupIds?.length === 0 || !(knownGroupIds.some(id => asset.groupIds?.includes(id))) ? ['ungruped'] : asset.groupIds,
      }));
      setAssets(normalizedAssets);

      setAssetGroups([
        ...groups,
        { id: FIELD_CAMPAIGN_GROUP_ID, name: "Campanha de campo" },
        { id: "ungruped", name: "Desagrupadas" },
      ]);

      setLoading(false);
      setDataLoaded(true);
    };

    if (!dataLoaded) fetchData();
  }, []);

  if (loading) {
    return <Loading label="Carregando..." />;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="display-flex flex-wrap gap-25 overflow-auto">
      <div className="w-full" style={{ height: 'calc(100vh - 50px)' }}>
        <TreeCategory
          key={CATEGORY_FILTER}
          id={CATEGORY_FILTER}
          label="Filter"
          icon="rioglyph-filter"
        />

        <TreeCategory
          key={CATEGORY_ASSETS}
          id={CATEGORY_ASSETS}
          label="Assets"
          icon="rioglyph-truck"
          hasSelection={!isEmpty(props.assetIds) || !isEmpty(props.groupIds)}
        >
          <UptimeSidebar
            allTags={assetGroups}
            allAssets={assets}
            setAssetIds={props.setAssetIds}
          />
        </TreeCategory>
      </div>

      <InfoDialog 
        show={showLimitDialog}
        title="Limite de seleção máximo"
        body={`Este é o limite de seleção máximo. Você pode selecionar no máximo ${props.selectionLimit} ${props.selectionLimit === 1 ? 'item' : 'itens'}.`}
        onClose={() => setShowLimitDialog(false)}
      />
    </div>
  );
};

export default AssetTreeSidebar;
